import { intersect, struct } from 'io-ts/Decoder';

import { Request as SearchRequest } from '../../../../report/estimate-outcome-trx';
import { Request as PaginationRequest } from '../../../generic/pagination/definite/Request';

export const Request = intersect(SearchRequest)(
	struct({
		pagination: PaginationRequest,
	})
);
